module.exports = __webpack_public_path__ + "img/homebanner3.cdc7ea61.png";